import React from "react";
import { Column, Row } from "@/shared/ui/Blocks";
import { cn } from "@/shared/utils/shadcn";
import { Title, TitleProps } from "../Title";
import { Icon } from "@/shared/ui/Icon";

export interface SectionHeaderProps extends Omit<TitleProps, "children"> {
  title: string;
  subtitle?: string;
  titleClassName?: string;
  RightComponent?: React.ReactNode;
}

function SectionHeader({
  title,
  subtitle,
  RightComponent,
  titleClassName,
  className,
  icon,
  iconSize,
  as = "h3",
  ...props
}: SectionHeaderProps) {
  const containerClasses = cn(
    "max-w-full md:w-full flex-col md:flex-row justify-between md:items-center pb-6 mb-8 border-b border-solid border-grey-300 gap-4",
    className
  );

  return (
    <Row className={containerClasses} {...props}>
      <Column>
        <Row className="items-start gap-3">
          {icon && (
            <Icon icon={icon} size={iconSize || "sm"} className="mt-[6px]" />
          )}
          <Title as={as} className={cn(titleClassName)} description={subtitle}>
            {title}
          </Title>
        </Row>
      </Column>
      {RightComponent}
    </Row>
  );
}

export { SectionHeader };
